import { FC } from "react";
import { AdaLogo } from "@/components/AdaLogo";
import type { AssetId } from "@module-bindings/types";
import { formatAssetLabel } from "@/lib/marketUtils";
import { getTokenIcon } from "@/lib/tokenMetadata";

export function TokenIcon({ name, className = "w-8 h-8" }: { name: string; className?: string }) {
  if (name === "ADA") return <AdaLogo className={className} />;
  const src = getTokenIcon(name);
  if (src) return <img src={src} alt={name} className={`${className} rounded-full`} />;
  return (
    <div className={`${className} rounded-full bg-sr-surface-raised flex items-center justify-center text-xs font-medium text-sr-pink-muted`}>
      {name.charAt(0).toUpperCase()}
    </div>
  );
}

export const PairIcon: FC<{
  base: AssetId;
  quote: AssetId;
  size?: number;
}> = ({ base, quote, size = 40 }) => {
  const iconSize = Math.round(size * 0.65);

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <div
        className="absolute top-0 left-0 rounded-full ring-2 ring-[#23141A] z-10"
        style={{ width: iconSize, height: iconSize }}
      >
        <TokenIcon name={formatAssetLabel(quote)} className="w-full h-full" />
      </div>
      <div
        className="absolute bottom-0 rounded-full ring-2 ring-[#23141A]"
        style={{ width: iconSize, height: iconSize, right: 0 }}
      >
        <TokenIcon name={formatAssetLabel(base)} className="w-full h-full" />
      </div>
    </div>
  );
};
